import { FaCartPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "./Contaxt";

function Navbar() {
  const { items } = useContext(AppContext);

  return (
    <>
      <div className="navbarr">
        <nav className="navbar  navbar-expand-lg bg-body-tertiary ">
          <div className="container-fluid ">
            <a className="navbar-brand" href="/">
              Buy Know
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link active" aria-current="page" to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="add">
                    Added Cart {<FaCartPlus />}{" "}
                    <span
                      class="top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{ padding: "4px" }}
                    >
                      {items.length}
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
